import { Container, Sprite, Texture } from 'pixi.js';

export class SpriteAnimation extends Container {
    private _frame: number = 0;
    private _frameCount: number = 0;
    private _textures: Texture[] = [];
    private _loop: boolean = false;
    private _running: boolean = false;
    private _speed: number = 0.15;
    private _sprite: Sprite = null;
    private _time: number = 0;

    constructor(textures: Texture[]) {
        super();

        this._frame = 0;
        this._frameCount = textures.length - 1;
        this._textures = textures;

        this._sprite = new Sprite();
        this._sprite.texture = this._textures[this._frame];
        this.addChild(this._sprite);
    }

    public reset() {
        this._frame = 0;
    }

    public update(frameRate: number): void {
        if (!this._running) {
            return;
        }

        if (this._frame >= this._frameCount) {
            if (!this._loop) {
                this._running = false;
                this.emit('complete', this);

            } else {
                this._frame = 0;
                this._time = 0;
            }
        } else {
            if (this._time >= this._speed / 10) {
                this._frame++;
                this._time = 0;

            } else {
                this._time += frameRate;
            }
        }

        this._sprite.texture = this._textures[this._frame];
    }

    public gotoAndPlay(frame: number): void {
        this._frame = frame;
        this._time = 0;
        this._running = true;
    }

    public set loop(value: boolean) {
        this._loop = value;
    }

    public set speed(value: number) {
        this._speed = value;
    }

    public set tint(value: number) {
        this._sprite.tint = value;
    }

    public get tint(): number {
        return this._sprite.tint;
    }
}
